"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyPress = void 0;
var react_1 = require("react");
/**
 * Добавляет событие при нажатии на клавиатуру
 * @link https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
 * @param key Клавиша-триггер
 * @param callback Коллбек, вызываемый при нажатии на клавишу
 */
var useKeyPress = function (key, callback) {
    (0, react_1.useEffect)(function () {
        var listener = function (e) {
            if (e.key === key) {
                callback();
            }
        };
        window.addEventListener('keydown', listener);
        return function () { return window.removeEventListener('keydown', listener); };
    }, [callback, key]);
};
exports.useKeyPress = useKeyPress;
